import type { SVGProps } from "react";
import * as React from "react";

const SvgBookOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3V2a1 1 0 0 0-1 1zm10 4h1zm-1 14a1 1 0 1 0 2 0zm-2-3v-1zm-7 0H1a1 1 0 0 0 1 1zM22 3h1a1 1 0 0 0-1-1zm-6 0V2zm-1 15v-1zm7 0v1a1 1 0 0 0 1-1zM2 4h6V2H2zm6 0a3 3 0 0 1 2.121.879l1.415-1.415A5 5 0 0 0 8 2zm2.121.879A3 3 0 0 1 11 7h2a5 5 0 0 0-1.464-3.536zM11 7v14h2V7zm2 14a4 4 0 0 0-1.172-2.828l-1.414 1.414A2 2 0 0 1 11 21zm-1.172-2.828A4 4 0 0 0 9 17v2a2 2 0 0 1 1.414.586zM9 17H2v2h7zm-6 1V3H1v15zM22 2h-6v2h6zm-6 0a5 5 0 0 0-3.536 1.464L13.88 4.88A3 3 0 0 1 16 4zm-3.536 1.464A5 5 0 0 0 11 7h2a3 3 0 0 1 .879-2.121zM13 21a2 2 0 0 1 .586-1.414l-1.414-1.414A4 4 0 0 0 11 21zm.586-1.414A2 2 0 0 1 15 19v-2a4 4 0 0 0-2.828 1.172zM15 19h7v-2h-7zm8-1V3h-2v15z"
    />
  </svg>
);
export default SvgBookOpen;
